// "Whom to blame" for a covert order (module `espionage.false_flag`).
//
// Shared by every hostile order, so the choice reads the same everywhere.
// Renders nothing while the module is off or there is no one to blame.

import type { PlayerHudEntry } from '@aod/ui';
import { useT } from '../../i18n/index.js';

export interface FramePickerProps {
  readonly testId: string;
  readonly falseFlag: boolean;
  /** The houses that may be blamed: never yourself, never the house struck. */
  readonly suspects: readonly PlayerHudEntry[];
  readonly value: number | null;
  readonly onChange: (seat: number | null) => void;
}

export function FramePicker({ testId, falseFlag, suspects, value, onChange }: FramePickerProps) {
  const t = useT();
  if (!falseFlag || suspects.length === 0) return null;
  return (
    <select
      data-testid={testId}
      aria-label={t('espionage.frameLabel')}
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}
      className="min-w-0 flex-1 rounded border border-border/60 bg-background px-1 py-0.5 text-[10px]"
    >
      <option value="">{t('espionage.frameNobody')}</option>
      {suspects.map((p) => (
        <option key={p.playerId} value={p.playerId}>
          {t('espionage.frameHouse', { house: p.name })}
        </option>
      ))}
    </select>
  );
}
